// extracted by mini-css-extract-plugin
module.exports = {"web3":"Web3Info_web3__2LwNW","dataPoint":"Web3Info_dataPoint__TLok1","value":"Web3Info_value__1D1hK"};